define('uikit/views/proxy.options.view',['require','exports','module','marionette','underscore','../channel','../mixins/component.mixin'],function(require, exports, module){
  var Mn = require('marionette');
  var _ = require('underscore');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  
  
  var ProxyOptionsView = Mn.ItemView.extend(ComponentMixin).extend({

    template: function() { return '<ui name="proxyView" />'; },

    internalViewOptions: {
      proxyView: function() {
        return _.extend({}, this.options, {
          type: this.getOption('proxyView')
        });
      }
    },
    internalViewBindings: {
      proxyView: function(name, childview) {
        var viewBindings = {};
        _.each(childview.options, function(value, option) {
          // make sure we have a property initialized for each option
          // so that events will work correctly
          this._initializeProperty(option, 'options');
          viewBindings[option] = option;
        }, this);
        return viewBindings;
      }
    }
  });

  module.exports = ProxyOptionsView;
});
